require('./RASummaryWidget.scss');

// @vendors
const React = require('react');
const { Fragment } = React;
const PropTypes = require('prop-types');
const classnames = require('classnames');
const { withRouter } = require('react-router-dom');
const { times } = require('lodash');
const Immutable = require('immutable');
const moment = require('moment');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const RACircularProgressIcon = require('../../components/commons/RACircularProgressIcon/RACircularProgressIcon');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKMessage } = require('commonsComponents/OKMessage');

// @components
const RAOneLineSymbolAmount = require('../commons/RAOneLineSymbolAmount/RAOneLineSymbolAmount');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const RAProbabilityTag = require('../RAProbabilityTag/RAProbabilityTag');

// @utilities
const { FormattedText } = require('core/i18n').i18n;
const RAPortfolioHelper = require('../../utilities/RAPortfolioHelper');
const RAArrayHelper = require('../../utilities/RAArrayHelper');
const RACurrencyHelper = require('../../utilities/RACurrencyHelper');
const { Portfolios } = require('../../utilities/RAPortfolioHelper');
const {
    recordLink,
    PROC_RA_GLOBAL_POSITION_INTERACTION,
} = require('utilities/tagging');

// @assets
const carImage = require('../../assets/icons/coche.png');
const travelImage = require('../../assets/icons/viaje.png');
const homeImage = require('../../assets/icons/casa.png');
const educationImage = require('../../assets/icons/educacion.png');
const otherImage = require('../../assets/icons/otro.png');
const objectiveSaveSimulationErrorImage = require('../../assets/icons/buildings/Objective_API_Error_Icon.svg');

// @constants
const {
    EURO_SYMBOL,
    MYPROFILE_BROKER_LESS_THAN_ONE,
    PERCENTAGE_SYMBOL,
} = require('constants/index');
const {
    DISABLED_PROBABILITY,
    GOAL_TRACKING_URL,
    HIGH_PROBABILITY,
    MEDIUM_PROBABILITY,
    MANAGEMENT_PLAN_URL,
    MYPROFILE_ROBO_SETGOAL,
    LOW_PROBABILITY,
    PORTFOLIO_TRACKING_URL,
    PROC_RA_HIRE,
    PROC_RA_GLOBAL_POSITION_OBJECTIVES_CARD,
    PROC_RA_GLOBAL_POSITION_SHOW_OBJECTIVE,
    PROC_RA_GLOBAL_POSITION_SHOW_WALLET,
    PROC_RA_GLOBAL_POSITION_WALLETS_CARD,
    RA_SUITABILITY_TEST_URL,
    SUMMARY_WIDGET_PAGE_SIZE,
    SAVE_SIMULATION,
} = require('../../raConstants/index');

class RASummaryWidget extends React.Component {
    constructor(props) {
        super(props);

        this.handleGoalItemClick = this.handleGoalItemClick.bind(this);
        this.handleGoalPageClick = this.handleGoalPageClick.bind(this);
        this.handleNewObjectiveClick = this.handleNewObjectiveClick.bind(this);
        this.handleNewStrategyClick = this.handleNewStrategyClick.bind(this);
        this.handleStrategyItemClick = this.handleStrategyItemClick.bind(this);
        this.handleStrategyPageClick = this.handleStrategyPageClick.bind(this);
        this.buildGoalStrategyItemNode = this.buildGoalStrategyItemNode.bind(
            this,
        );
        this.buildSaveGoalAndStrategyList = this.buildSaveGoalAndStrategyList.bind(
            this,
        );
        this.state = {
            goalPageNumber: 1,
            strategyPageNumber: 1,
        };
    }

    handleGoalItemClick(portfolioID) {
        recordLink(
            PROC_RA_GLOBAL_POSITION_INTERACTION,
            PROC_RA_GLOBAL_POSITION_SHOW_OBJECTIVE,
        );
        this.props.history.push(`${GOAL_TRACKING_URL}/${portfolioID}`);
    }

    handleStrategyItemClick(portfolioID) {
        recordLink(
            PROC_RA_GLOBAL_POSITION_INTERACTION,
            PROC_RA_GLOBAL_POSITION_SHOW_WALLET,
        );
        this.props.history.push(`${PORTFOLIO_TRACKING_URL}/${portfolioID}`);
    }

    handleGoalPageClick(ev) {
        this.setState({
            goalPageNumber: parseInt(ev.currentTarget.dataset.id),
        });
    }

    handleNewObjectiveClick() {
        const { onNewObjectiveClick } = this.props;
        recordLink(
            PROC_RA_GLOBAL_POSITION_INTERACTION,
            PROC_RA_HIRE,
            PROC_RA_GLOBAL_POSITION_OBJECTIVES_CARD,
        );
        onNewObjectiveClick();
    }

    handleNewStrategyClick() {
        const { onNewStrategyClick } = this.props;
        recordLink(
            PROC_RA_GLOBAL_POSITION_INTERACTION,
            PROC_RA_HIRE,
            PROC_RA_GLOBAL_POSITION_WALLETS_CARD,
        );
        onNewStrategyClick();
    }

    handleStrategyPageClick(ev) {
        this.setState({
            strategyPageNumber: parseInt(ev.currentTarget.dataset.id),
        });
    }

    getTotalWithOutSimulation(data) {
        let total = 0;
        Object.entries(data.toJS()).forEach(([, goal]) => {
            goal.simulationId ? total : (total += 1);
        });

        return total;
    }

    getIconImage(goalType) {
        switch (goalType) {
            // @Temporally logic, TODO: change RACircularProgressIcon to implement as modifier class
            case 'CAR':
                return carImage;
            case 'TRAVEL':
                return travelImage;
            case 'HOME':
                return homeImage;
            case 'EDUCATION':
                return educationImage;
            case 'OTHERS':
                return otherImage;
            case 'ERROR':
                return objectiveSaveSimulationErrorImage;
            default:
                return '';
        }
    }

    buildPagination(size, pageNumber, handlePageClick) {
        const portfoliosPerpage = 3;
        const numberOfCircles = Math.ceil(size / portfoliosPerpage);
        let circles = [];
        for (
            let circleNumber = 1;
            circleNumber <= numberOfCircles;
            circleNumber++
        ) {
            const circleClasname = classnames(
                'ra-summary-widget__list-circle',
                {
                    'ra-summary-widget__list-circle--active':
                        pageNumber === circleNumber,
                },
            );
            const circle = (
                <div
                    key={circleNumber}
                    className={circleClasname}
                    data-id={circleNumber}
                    onClick={handlePageClick}
                />
            );
            circles.push(circle);
        }
        return <div className="ra-summary-widget__pagination">{circles}</div>;
    }

    buildTooltipContent() {
        return (
            <div className="ra-summary-widget__tooltip-content">
                <header className="ra-summary-widget__tooltip-header">
                    <FormattedText value="raSummaryWidget-raSummaryWidget_tooltipInfo" />
                </header>
                <div className="ra-summary-widget__tooltip-body">
                    <div className="ra-summary-widget__tooltip-row row">
                        <div className="col-md-4">
                            <RAProbabilityTag label={HIGH_PROBABILITY} />
                        </div>
                        <div className="col-md-8">
                            <FormattedText
                                value={
                                    'raSummaryWidget-raSummaryWidget_highDescription'
                                }
                            />
                        </div>
                    </div>
                    <div className="ra-summary-widget__tooltip-row row">
                        <div className="col-md-4">
                            <RAProbabilityTag label={MEDIUM_PROBABILITY} />
                        </div>
                        <div className="col-md-8">
                            <FormattedText
                                value={
                                    'raSummaryWidget-raSummaryWidget_mediumDescription'
                                }
                            />
                        </div>
                    </div>
                    <div className="ra-summary-widget__tooltip-row row">
                        <div className="col-md-4">
                            <RAProbabilityTag label={LOW_PROBABILITY} />
                        </div>
                        <div className="col-md-8">
                            <FormattedText
                                value={
                                    'raSummaryWidget-raSummaryWidget_lowDescription'
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildGoalHeaderSubInfoContent() {
        const tooltipContent = this.buildTooltipContent();
        return (
            <div className="ra-summary-widget__header-info-block">
                <div className="ra-summary-widget__header-info-content-left">
                    <span className="ra-summary-widget__info-small">
                        <FormattedText value="raSummaryWidget-raSummaryWidget_tooltipInfo" />
                    </span>
                    <div className="ra-summary-widget__circle-wrapper">
                        <div className="ra-summary-widget__circle ra-summary-widget__circle--high" />
                        <div className="ra-summary-widget__circle ra-summary-widget__circle--medium" />
                        <div className="ra-summary-widget__circle ra-summary-widget__circle--low" />
                    </div>
                    <OKTooltip
                        content={tooltipContent}
                        modifier="dark-bg"
                        offset={[0, -15]}
                        type="custom"
                    />
                </div>
                <div className="ra-summary-widget__header-info-content-right">
                    <FormattedText
                        value="raSummaryWidget-raSummaryWidget_currentValue"
                        className="ra-summary-widget__info-secondary"
                    />
                </div>
            </div>
        );
    }

    buildGoalHeader(goalSize, maxPortfoliosReached) {
        const counter = (
            <div className="ra-summary-widget__counter">({goalSize})</div>
        );
        let button;
        let headerSubInfoContent;
        button = (
            <div className="ra-summary-widget__cta-wrapper">
                <OKButton
                    size="small"
                    onClick={this.handleNewObjectiveClick}
                    disabled={maxPortfoliosReached}
                >
                    <FormattedText value="raSummaryWidget-raSummaryWidget_ctaGoalText" />
                </OKButton>
            </div>
        );
        headerSubInfoContent = this.buildGoalHeaderSubInfoContent();

        return (
            <header className="ra-summary-widget__heading-group">
                <div className="ra-summary-widget__cta-block">
                    <FormattedTextWithComponents
                        value="raSummaryWidget-raSummaryWidget_goalTitle"
                        className="ra-summary-widget__subtitle"
                        injectedComponents={[counter]}
                    />
                    {button}
                </div>
                {headerSubInfoContent}
            </header>
        );
    }

    buildStrategyHeader(strategySize, maxPortfoliosReached) {
        const counter = (
            <div className="ra-summary-widget__counter">({strategySize})</div>
        );
        let currentValuation;
        let button;
        if (strategySize > 0) {
            currentValuation = (
                <FormattedText
                    value="raSummaryWidget-raSummaryWidget_currentValue"
                    className="ra-summary-widget__info-secondary"
                />
            );
            button = (
                <div className="ra-summary-widget__cta-wrapper">
                    <OKButton
                        size="small"
                        onClick={this.handleNewStrategyClick}
                        disabled={maxPortfoliosReached}
                    >
                        <FormattedText value="raSummaryWidget-raSummaryWidget_ctaStrategyText" />
                    </OKButton>
                </div>
            );
        }

        return (
            <header className="ra-summary-widget__heading-group">
                <div className="ra-summary-widget__cta-block">
                    <FormattedTextWithComponents
                        value="raSummaryWidget-raSummaryWidget_strategyTitle"
                        className="ra-summary-widget__subtitle"
                        injectedComponents={[counter]}
                    />
                    {button}
                </div>
                <div className="ra-summary-widget__header-info-content">
                    {currentValuation}
                </div>
            </header>
        );
    }

    buildEmptyListItemNode(emptyRowsNumber, isGoalSection) {
        const emptyAmount = {
            amount: 0,
            currency: EURO_SYMBOL,
        };

        let icon;
        let infoBlock;
        if (isGoalSection) {
            const emptyPercentage = RACurrencyHelper.formatPercentage(0);
            icon = (
                <div className="ra-summary-widget__outer-circle">
                    <div className="ra-summary-widget__inner-circle">
                        <i className="icon icon-nuevos-objetivos ra-summary-widget__placeholder-icon ra-summary-widget__placeholder-icon--goal" />
                    </div>
                </div>
            );
            infoBlock = (
                <div className="ra-summary-widget__info-block ra-summary-widget__info-block--disabled">
                    <div className="ra-summary-widget__info-header">
                        <FormattedText value="raSummaryWidget-raSummaryWidget_emptyTitleGoal" />
                    </div>
                    <div className="ra-summary-widget__info-body">
                        <div className="ra-summary-widget__wrapper-tag">
                            <RAProbabilityTag label={DISABLED_PROBABILITY} />
                        </div>
                        <span className="ra-summary-widget__info-primary">
                            {emptyPercentage}
                        </span>
                        <div className="ra-summary-widget__info-body-right-content">
                            <RAOneLineSymbolAmount
                                amountObject={emptyAmount}
                                className="ra-summary-widget__info-primary"
                            />
                        </div>
                    </div>
                </div>
            );
        } else {
            icon = (
                <div className="ra-summary-widget__placeholder-circle">
                    <i className="icon icon-carteras-tower ra-summary-widget__placeholder-icon ra-summary-widget__placeholder-icon--strategy" />
                </div>
            );
            infoBlock = (
                <div className="ra-summary-widget__info-block ra-summary-widget__info-block--center ra-summary-widget__info-block--disabled">
                    <div className="ra-summary-widget__info-header ra-summary-widget__info-header--floated">
                        <FormattedText value="raSummaryWidget-raSummaryWidget_emptyTitleStrategy" />
                    </div>
                    <div className="ra-summary-widget__info-body-right-content">
                        <RAOneLineSymbolAmount
                            amountObject={emptyAmount}
                            className="ra-summary-widget__info-primary"
                        />
                    </div>
                </div>
            );
        }

        const emptyList = times(emptyRowsNumber, index => {
            return (
                <div key={index}>
                    <div className="ra-summary-widget__list-item">
                        <div className="row">
                            <div className="col-md-2">
                                <div className="ra-summary-widget__icon-wrapper">
                                    {icon}
                                </div>
                            </div>
                            <div className="col-md-10">{infoBlock}</div>
                        </div>
                    </div>
                </div>
            );
        });

        return emptyList;
    }

    buildGoalList(immGoals, pageNumber) {
        const immPaginateGoals = RAArrayHelper.paginate(
            immGoals,
            SUMMARY_WIDGET_PAGE_SIZE,
            pageNumber,
        );

        const list = immPaginateGoals.entrySeq().map((entry, index) => {
            if (!!entry[1].get('simulationId')) {
                return (
                    <div key={index}>
                        {this.buildSaveGoalAndStrategyList('Goal', entry[1])}
                    </div>
                );
            }
            const id = entry[0];
            const immGoal = entry[1];
            const goalName = immGoal.getIn(['goalInformation', 'name']);
            const goalType = immGoal.getIn(['goalInformation', 'goalType']);
            const probability = immGoal.getIn([
                'goalInformation',
                'probability',
            ]);
            const goalProgress = immGoal.getIn([
                'goalInformation',
                'goalProgress',
            ]);
            const goalDate = immGoal.getIn(['goalInformation', 'goalDate']);
            const formattedGoalProgress = RACurrencyHelper.formatWithoutRoundedPercentage(
                goalProgress,
                false,
            );
            const circularIcon = this.getIconImage(goalType);
            const amountObject = {
                amount: immGoal.getIn(['keyFigures', 'valuation']),
                currency: EURO_SYMBOL,
            };
            const isProductChangeInProgress = immGoal.getIn([
                'state',
                'productChangeInProgress',
            ]); //strategyChange
            let productChange;
            if (isProductChangeInProgress) {
                productChange = (
                    <i className="ra-summary-widget__info-icon ra-summary-widget__info-icon--pull-right icon-advertencia" />
                );
            }

            let parsedGoalProgress;
            if (formattedGoalProgress > 0 && formattedGoalProgress < 1) {
                parsedGoalProgress = MYPROFILE_BROKER_LESS_THAN_ONE;
            } else {
                parsedGoalProgress = RACurrencyHelper.formatPercentage(
                    goalProgress,
                    false,
                    false,
                );
            }

            const isGoalReached = goalProgress >= 1;
            const isGoalNonReached =
                goalProgress < 1 &&
                moment(goalDate).isSameOrBefore(moment(), 'day');
            let probabilityContent = <RAProbabilityTag label={probability} />;
            if (isGoalReached || isGoalNonReached) {
                probabilityContent = null;
            }
            const objectiveIconNode = (
                <div className="ra-summary-widget__icon-wrapper">
                    <RACircularProgressIcon
                        progress={formattedGoalProgress}
                        size={62}
                        url={circularIcon}
                        nonReached={isGoalNonReached}
                    />
                </div>
            );
            const objectiveInfoTooltip = (
                <div className="ra-summary-widget__objective-tooltip">
                    <span className="ra-summary-widget__objective-tooltipinfo">
                        {parsedGoalProgress}
                        {PERCENTAGE_SYMBOL}{' '}
                        <FormattedText value="raSummaryWidget-raSummaryWidget_objectiveTooltipContent" />
                    </span>
                    <FormattedText value="raSummaryWidget-raSummaryWidget_objectiveTooltipInfo" />
                </div>
            );
            const goalListItemNodeData = (
                <div className="ra-summary-widget__description">
                    <div className="ra-summary-widget__info-block">
                        <div className="ra-summary-widget__info-header">
                            {goalName}
                            {productChange}
                        </div>
                        <div className="ra-summary-widget__info-body">
                            <div className="ra-summary-widget__wrapper-tag">
                                {probabilityContent}
                            </div>
                            <span className="ra-summary-widget__info-primary">
                                {parsedGoalProgress}
                                {PERCENTAGE_SYMBOL}
                            </span>
                            <div className="ra-summary-widget__info-body-right-content">
                                <RAOneLineSymbolAmount
                                    amountObject={amountObject}
                                    className="ra-summary-widget__info-primary"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            );
            let goalListItemNode;
            if (immGoal.getIn(['state', 'cancelled'])) {
                goalListItemNode = (
                    <OKTooltip
                        content="raSummaryWidget-raSummaryWidget_cancelInProgress"
                        offset={[0, -15]}
                        target={goalListItemNodeData}
                    />
                );
            } else if (isProductChangeInProgress) {
                goalListItemNode = (
                    <OKTooltip
                        content="raSummaryWidget-raSummaryWidget_changeInProgress"
                        offset={[0, -15]}
                        target={goalListItemNodeData}
                    />
                );
            } else {
                goalListItemNode = goalListItemNodeData;
            }

            return (
                <div
                    key={id}
                    onClick={() => {
                        this.handleGoalItemClick(id);
                    }}
                >
                    <div className="ra-summary-widget__list-item">
                        <div className="ra-summary-widget__list-item-columns">
                            <OKTooltip
                                content={objectiveInfoTooltip}
                                offset={[0, -10]}
                                target={objectiveIconNode}
                            />
                            {goalListItemNode}
                        </div>
                    </div>
                </div>
            );
        });

        return this.buildGoalStrategyItemNode(list, immPaginateGoals, true);
    }

    buildStrategyList(immStrategies, pageNumber) {
        const immPaginateStrategies = RAArrayHelper.paginate(
            immStrategies,
            SUMMARY_WIDGET_PAGE_SIZE,
            pageNumber,
        );

        const list = immPaginateStrategies.entrySeq().map((entry, index) => {
            if (entry[1].get('newProfile')) {
                return (
                    <div key={index}>
                        {this.buildSaveGoalAndStrategyList(
                            'Staretegy',
                            entry[1],
                        )}
                    </div>
                );
            }
            const id = entry[0];
            const immStrategy = entry[1];
            const strategyName = immStrategy.get('name');
            const amountObject = {
                amount: immStrategy.getIn(['keyFigures', 'valuation']),
                currency: EURO_SYMBOL,
            };
            const typeOfProduct = immStrategy.getIn([
                'product',
                'typeOfProduct',
            ]);
            const iconClassName = classnames(
                'ra-summary-widget__icon-product',
                `ra-summary-widget__icon-product--${typeOfProduct}`,
            );
            const isStrategyChangeInProgress = immStrategy.getIn([
                'state',
                'productChangeInProgress',
            ]); //strategyChange
            let strategyChange;
            if (isStrategyChangeInProgress) {
                strategyChange = (
                    <i className="ra-summary-widget__info-icon icon-advertencia" />
                );
            }
            const pendingCancellationCommisionDisclaimer = immStrategy.getIn([
                'state',
                'hasPendingCancellationCommision',
            ]) ? (
                <div className="ra-summary-widget__has-pending-cancellation-commision-disclaimer">
                    <OKMessage>
                        <FormattedText value="raSummaryWidget-raSummaryWidget_alertBannerContent" />
                    </OKMessage>
                </div>
            ) : null;
            const strategyListItemNode = (
                <div>
                    <div className="row">
                        <div className="col-md-2">
                            <div className={iconClassName} />
                        </div>
                        <div className="col-md-10">
                            <div className="ra-summary-widget__info-block ra-summary-widget__info-block--center">
                                <div className="ra-summary-widget__info-header ra-summary-widget__info-header--floated">
                                    {strategyName}
                                </div>
                                <div className="ra-summary-widget__info-body-right-content">
                                    {strategyChange}
                                    <RAOneLineSymbolAmount
                                        amountObject={amountObject}
                                        className="ra-summary-widget__info-primary"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {pendingCancellationCommisionDisclaimer}
                </div>
            );

            let strategyListItem;
            if (immStrategy.getIn(['state', 'cancelled'])) {
                strategyListItem = (
                    <OKTooltip
                        content="raSummaryWidget-raSummaryWidget_cancelInProgress"
                        offset={[0, -15]}
                        target={strategyListItemNode}
                    />
                );
            } else if (isStrategyChangeInProgress) {
                // strategy changed in progress
                strategyListItem = (
                    <OKTooltip
                        content="raSummaryWidget-raSummaryWidget_changeInProgress"
                        offset={[0, -15]}
                        target={strategyListItemNode}
                    />
                );
            } else {
                strategyListItem = strategyListItemNode;
            }
            return (
                <div
                    key={id}
                    onClick={() => {
                        this.handleStrategyItemClick(id);
                    }}
                >
                    <div className="ra-summary-widget__list-item">
                        {strategyListItem}
                    </div>
                </div>
            );
        });
        return this.buildGoalStrategyItemNode(
            list,
            immPaginateStrategies,
            false,
        );
    }

    buildGoalStrategyItemNode(list, immPaginateGoalsStrategies, isGoalSection) {
        const emptyRowsNumber =
            SUMMARY_WIDGET_PAGE_SIZE - immPaginateGoalsStrategies.size;
        const emptyListItems =
            emptyRowsNumber > 0
                ? this.buildEmptyListItemNode(emptyRowsNumber, isGoalSection)
                : null;

        return (
            <Fragment>
                {list}
                {emptyListItems}
            </Fragment>
        );
    }

    buildComponentAd(type, maxPortfoliosReached) {
        const handleTypeClick =
            type === 'goal'
                ? this.props.onNewObjectiveClick
                : this.props.onNewStrategyClick;
        const className = `ra-summary-widget__ad ra-summary-widget__ad-${type}`;
        return (
            <div className={className}>
                <div className="ra-summary-widget__ad-wrapper">
                    <p className="ra-summary-widget__ad-title">
                        <FormattedText
                            value={
                                type === 'goal'
                                    ? 'raSummaryWidget-raSummaryWidget_goalAdTitle'
                                    : 'raSummaryWidget-raSummaryWidget_portfolioAdTitle'
                            }
                        />
                    </p>
                    <p className="ra-summary-widget__ad-description">
                        <FormattedText
                            value={
                                type === 'goal'
                                    ? 'raSummaryWidget-raSummaryWidget_goalAdDescription'
                                    : 'raSummaryWidget-raSummaryWidget_portfolioAdDescription'
                            }
                        />
                    </p>
                    <OKButton
                        modifier="primary"
                        disabled={maxPortfoliosReached}
                        onClick={handleTypeClick}
                    >
                        <FormattedText
                            value={
                                type === 'goal'
                                    ? 'raSummaryWidget-raSummaryWidget_goalAdButton'
                                    : 'raSummaryWidget-raSummaryWidget_portfolioAdButton'
                            }
                        />
                    </OKButton>
                </div>
            </div>
        );
    }

    buildFooter(totalValuation) {
        const totalAmount = {
            amount: totalValuation,
            currency: EURO_SYMBOL,
        };

        return (
            <div className="ra-summary-widget__footer">
                <FormattedText
                    value="raSummaryWidget-raSummaryWidget_footerInfo"
                    className="ra-summary-widget__footer-content-left"
                />
                <RAOneLineSymbolAmount
                    amountObject={totalAmount}
                    className="ra-summary-widget__footer-content-right"
                />
            </div>
        );
    }

    buildSaveGoalAndStrategyList(type, saveSimulationObject) {
        let listNodeName =
            type == 'Goal'
                ? saveSimulationObject.get('name')
                : saveSimulationObject.get('portfolioCustomName') ||
                  saveSimulationObject.get('name');
        let icon,
            objectiveIconNode,
            link,
            saveSimulationTagNode,
            listNodeNameClass;

        if (type != 'Goal') {
            //Portfolio Data
            link = this.props.isTestActive
                ? MANAGEMENT_PLAN_URL
                : RA_SUITABILITY_TEST_URL;
            icon = classnames(
                'ra-summary-widget__icon-product',
                `ra-summary-widget__icon-product--${saveSimulationObject.get(
                    'newProfile',
                )}`,
            );
        } else {
            //Objective Data
            link = MYPROFILE_ROBO_SETGOAL;
            icon = this.getIconImage(
                saveSimulationObject.get('type').toUpperCase(),
            );
        }

        if (!saveSimulationObject.get('error')) {
            //IF error is not there set these values are for Objective and Portfolio
            saveSimulationTagNode = (
                <div className="ra-summary-widget__info-body">
                    <div className="ra-summary-widget__wrapper-tag">
                        <RAProbabilityTag label={SAVE_SIMULATION} />
                    </div>
                </div>
            );
            listNodeNameClass = 'ra-summary-widget__info-header';
            objectiveIconNode =
                type != 'Goal' ? (
                    <div className={icon} />
                ) : (
                    <div className="ra-summary-widget__icon-wrapper">
                        <RACircularProgressIcon
                            progress={MYPROFILE_BROKER_LESS_THAN_ONE}
                            size={62}
                            url={icon}
                        />
                    </div>
                );
        } else {
            //Handling ERROR state in case of API Failure
            listNodeNameClass = 'ra-summary-widget__info-header--error';
            const iconName =
                type != 'Goal' && listNodeName ? (
                    <img
                        src={
                            Portfolios[saveSimulationObject.get('newProfile')]
                                .icon
                        }
                    />
                ) : (
                    <img src={icon} />
                );
            objectiveIconNode = (
                <div className="ra-summary-widget__outer-circle-save-simulation-error">
                    <div className="ra-summary-widget__inner-circle--save-simulation-error">
                        {iconName}
                    </div>
                </div>
            );
        }

        const goalListItemNodeData = (
            <div
                onClick={() => {
                    if (!saveSimulationObject.get('error')) {
                        this.props.handleSaveGoalItemClick(link);
                    }
                }}
            >
                <div className="ra-summary-widget__list-item">
                    <div className="ra-summary-widget__list-item-columns">
                        {objectiveIconNode}
                        <div className="ra-summary-widget__description">
                            <div className="ra-summary-widget__info-block">
                                <div className={listNodeNameClass}>
                                    {listNodeName}
                                </div>
                                {saveSimulationTagNode}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
        return <div>{goalListItemNodeData}</div>;
    }

    render() {
        const { goalPageNumber, strategyPageNumber } = this.state;
        const {
            immGlobalPosition,
            immManagementPlan,
            immSimulation,
            immSaveSimulation,
        } = this.props;

        if (
            immManagementPlan.get('isFetchingInvestProfile') ||
            immSimulation.get('isFetching')
        ) {
            return <LoadingSection />;
        }

        const immPortfolios = immGlobalPosition.get('portfolios');
        const immGoals = RAPortfolioHelper.filterByGoals(immPortfolios);
        const immStrategies = RAPortfolioHelper.filterPurePortfolios(
            immPortfolios,
        );
        let goalData, strategyData;
        const checkActivePortfolioAndObjective =
            immStrategies.size || immGoals.size;

        if (
            checkActivePortfolioAndObjective &&
            immSaveSimulation &&
            immSaveSimulation.getIn(['saveSimulationObjective', 'simulationId'])
        ) {
            //User have saved simulation then combining goalsObject and saveSimulationGoalObject to show the list of Goals on Landing of Robo
            goalData = Immutable.fromJS(
                immGoals.merge({
                    [immSaveSimulation.getIn([
                        'saveSimulationObjective',
                        'simulationId',
                    ])]: immSaveSimulation.getIn(['saveSimulationObjective']),
                }),
            );
        } else {
            //User don't have any save simulation use immGoals
            goalData = immGoals;
        }

        if (
            checkActivePortfolioAndObjective &&
            immSaveSimulation &&
            immSaveSimulation.getIn(['saveSimulationPortfolio', 'simulationId'])
        ) {
            //User have saved simulation then combining strategiesObject and immManagementPlan to show the list of Stategies on Landing of Robo
            strategyData = Immutable.fromJS(
                immStrategies.merge({
                    [immSaveSimulation.getIn([
                        'saveSimulationPortfolio',
                        'simulationId',
                    ])]: immSaveSimulation.getIn(['saveSimulationPortfolio']),
                }),
            );
        } else {
            //User don't have any save simulation use immStrategies
            strategyData = immStrategies;
        }

        const goalSize = goalData.size;
        const strategySize = strategyData.size;
        const goalSizeWithOutSimulation = this.getTotalWithOutSimulation(
            goalData,
        );
        const strategySizeWithOutSimulation = this.getTotalWithOutSimulation(
            strategyData,
        );

        const maxPortfoliosReached = immGlobalPosition.getIn([
            'roboAdvisor',
            'maxAccountsReached',
        ]);
        const totalValuation = immGlobalPosition.getIn([
            'roboAdvisor',
            'totals',
            'valuation',
        ]);

        const goalHeader = this.buildGoalHeader(
            goalSizeWithOutSimulation,
            maxPortfoliosReached,
        );
        const strategyHeader = this.buildStrategyHeader(
            strategySizeWithOutSimulation,
            maxPortfoliosReached,
        );
        const footer = this.buildFooter(totalValuation);
        let goalList;
        let goalPagination;
        let strategyList;
        let strategyPagination;

        if (goalSize > 0) {
            goalList = this.buildGoalList(goalData, goalPageNumber);
            goalPagination = this.buildPagination(
                goalSize,
                goalPageNumber,
                this.handleGoalPageClick,
            );
        } else {
            goalList = this.buildComponentAd('goal', maxPortfoliosReached);
        }

        if (strategySize > 0) {
            strategyList = this.buildStrategyList(
                strategyData,
                strategyPageNumber,
            );
            strategyPagination = this.buildPagination(
                strategySize,
                strategyPageNumber,
                this.handleStrategyPageClick,
            );
        } else {
            strategyList = this.buildComponentAd(
                'portfolio',
                maxPortfoliosReached,
            );
        }

        return (
            <section className="ra-summary-widget">
                <h2 className="ra-summary-widget__title">
                    <FormattedText value="raSummaryWidget-raSummaryWidget_title" />
                </h2>
                <div className="ra-summary-widget__body">
                    <div className="ra-summary-widget__objectives">
                        {goalHeader}
                        <div className="ra-summary-widget__content">
                            <div className="ra-summary-widget__list">
                                {goalList}
                            </div>
                            {goalPagination}
                        </div>
                    </div>
                    <div className="ra-summary-widget__wallets">
                        {strategyHeader}
                        <div className="ra-summary-widget__content">
                            <div className="ra-summary-widget__list">
                                {strategyList}
                            </div>
                            {strategyPagination}
                        </div>
                    </div>
                </div>
                {footer}
            </section>
        );
    }
}

RASummaryWidget.propTypes = {
    history: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    immManagementPlan: PropTypes.object.isRequired,
    immSaveSimulation: PropTypes.object.isRequired,
    immSimulation: PropTypes.object.isRequired,
    isTestActive: PropTypes.bool.isRequired,
    onNewObjectiveClick: PropTypes.func.isRequired,
    onNewStrategyClick: PropTypes.func.isRequired,
    handleSaveGoalItemClick: PropTypes.func.isRequired,
};

module.exports = withRouter(RASummaryWidget);
